export const isWithinPercent = (
  value: number,
  target: number,
  percent: number,
): boolean => {
  if (
    value == null ||
    isNaN(value) ||
    target == null ||
    isNaN(target) ||
    target === 0
  ) {
    return false;
  }
  return Math.abs(value - target) / Math.abs(target) <= percent / 100;
};
